import React, { memo } from "react"
import { useSelector } from "react-redux"

import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import ProjectSubmit from "./ProjectSubmit"
import ProjectSetting from "./ProjectSetting"
import ParticipantForm from "./ParticipantForm"

const useStyles = makeStyles((theme) => ({
    sidebarContent: {
        [theme.breakpoints.up("md")]: {
            zIndex: "1100",
            position: "fixed",
            maxHeight: "80vh",
            overflowY: "auto",
        },
    },
}))

const ControlPanelSidebarFormContent = memo((props) => {
    const classes = useStyles()
    const { handleModalCompleteProjectShowChange } = props
    const controlPanelSidebarStatus = useSelector((state) => state.controlPanelSidebarReducer)

    return (
        <Box className={classes.sidebarContent}>
            <Box component="section">
                {controlPanelSidebarStatus.openComponent === process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PROJECT_SETTINGS ? (
                    <ProjectSetting />
                ) : null}
                {controlPanelSidebarStatus.openComponent === process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PARTICIPANT_SETTINGS ? (
                    <ParticipantForm />
                ) : null}
                {controlPanelSidebarStatus.openComponent === process.env.SPARCA_CONTROL_PANEL_SIDEBAR_ICONS_SELECT ? (
                    <Box>
                        <ProjectSubmit handleModalCompleteProjectShowChange={handleModalCompleteProjectShowChange} />
                        <ProjectSetting />
                        <ParticipantForm />
                    </Box>
                ) : null}
            </Box>
        </Box>
    )
})

export default ControlPanelSidebarFormContent
